const colors = ["#0f6f78", "#e99b42", "#3969ac", "#d6534d", "#5b9d62", "#8064a2"];

const base = {
  color: colors,
  animationDuration: 550,
  textStyle: { fontFamily: "Inter, Arial, sans-serif", color: "#344054" },
  tooltip: { trigger: "axis", confine: true },
  legend: { bottom: 0, type: "scroll" },
};

export function categoryChart(data, type = "bar", options = {}) {
  if (!data) return {};
  const horizontal = options.horizontal === true;
  const categoryAxis = {
    type: "category",
    data: data.categories || [],
    axisLabel: { interval: 0, rotate: horizontal ? 0 : 25, color: "#667085" },
    axisLine: { lineStyle: { color: "#d0d5dd" } },
  };
  const valueAxis = {
    type: "value",
    name: options.valueName || "",
    splitLine: { lineStyle: { color: "#eef2f6" } },
  };

  return {
    ...base,
    grid: {
      left: horizontal ? 145 : 45,
      right: options.secondAxis ? 55 : 20,
      top: 25,
      bottom: 65,
      containLabel: false,
    },
    xAxis: horizontal ? valueAxis : categoryAxis,
    yAxis: horizontal ? categoryAxis : options.yAxis || valueAxis,
    dataZoom: options.zoom
      ? [{ type: "inside" }, { type: "slider", height: 18, bottom: 28 }]
      : undefined,
    series: (data.series || []).map((series, index) => ({
      ...series,
      type: options.types ? options.types[index] || type : type,
      smooth: type === "line" || (options.types && options.types[index] === "line"),
      stack: options.stack ? "total" : undefined,
      yAxisIndex: options.secondAxis && index === (data.series || []).length - 1 ? 1 : 0,
      barMaxWidth: 34,
      emphasis: { focus: "series" },
    })),
  };
}

export function mixedCategoryChart(data, options = {}) {
  const option = categoryChart(data, "bar", {
    types: options.types,
    secondAxis: options.secondAxis !== false,
    zoom: options.zoom,
  });
  option.yAxis = [
    {
      type: "value",
      name: options.leftName || "",
      splitLine: { lineStyle: { color: "#eef2f6" } },
    },
    {
      type: "value",
      name: options.rightName || "",
      splitLine: { show: false },
    },
  ];
  if (options.secondAxis === false) option.yAxis = option.yAxis[0];
  return option;
}

export function pieChart(items, options = {}) {
  return {
    ...base,
    tooltip: { trigger: "item", confine: true },
    legend: { type: "scroll", bottom: 0 },
    series: [
      {
        name: options.name || "Total",
        type: "pie",
        radius: options.donut === false ? [0, "72%"] : ["42%", "70%"],
        center: ["50%", "44%"],
        avoidLabelOverlap: true,
        itemStyle: { borderColor: "#fff", borderWidth: 3, borderRadius: 5 },
        label: { formatter: "{b}\n{d}%", color: "#475467" },
        data: items || [],
      },
    ],
  };
}

export function gaugeChart(value, slaDays) {
  return {
    series: [
      {
        type: "gauge",
        startAngle: 210,
        endAngle: -30,
        min: 0,
        max: 100,
        progress: { show: true, width: 18, itemStyle: { color: "#0f6f78" } },
        axisLine: {
          lineStyle: {
            width: 18,
            color: [[0.5, "#f4b7b2"], [0.8, "#f6d58d"], [1, "#a7d7bd"]],
          },
        },
        axisTick: { show: false },
        splitLine: { distance: -23, length: 10, lineStyle: { color: "#fff", width: 2 } },
        axisLabel: { distance: 28, color: "#667085" },
        pointer: { length: "62%", width: 5 },
        detail: { valueAnimation: true, formatter: "{value}%", fontSize: 27, offsetCenter: [0, "47%"] },
        title: { offsetCenter: [0, "72%"], color: "#667085" },
        data: [{ value: value == null ? null : value, name: `SLA ${slaDays || 1}d` }],
      },
    ],
  };
}

export function datasetHorizontalBar(source, category, value, seriesName) {
  return {
    ...base,
    dataset: { source: source || [] },
    grid: { left: 165, right: 25, top: 20, bottom: 55 },
    xAxis: { type: "value", splitLine: { lineStyle: { color: "#eef2f6" } } },
    yAxis: { type: "category", axisLabel: { width: 145, overflow: "truncate" } },
    series: [{
      name: seriesName,
      type: "bar",
      encode: { x: value, y: category },
      barMaxWidth: 26,
      itemStyle: { borderRadius: [0, 5, 5, 0] },
    }],
  };
}
